import { render, staticRenderFns } from "./fieldsButton.vue?vue&type=template&id=83c8d048"
import script from "./fieldsButton.vue?vue&type=script&lang=js"
export * from "./fieldsButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports